/**
 * PIX Tooltip Component
 * Gerencia a exibição de tooltips informativos sobre desconto PIX
 */

class PixTooltip {
  constructor(button, autoCloseTime = 0) {
    this.button = button;
    this.tooltipContainer = button.nextElementSibling;
    this.tooltip = this.tooltipContainer?.querySelector('.pix-tooltip');
    this.isActive = false;
    this.autoCloseTime = autoCloseTime; // Tempo em segundos (0 = não fecha automaticamente)
    this.autoCloseTimer = null;
    
    this.init();
  }
  
  init() {
    if (!this.tooltipContainer || !this.tooltipContainer.classList.contains('pix-tooltip-container')) {
      console.warn('Tooltip container element not found');
      return;
    }
    
    if (!this.tooltip) {
      console.warn('Tooltip element not found');
      return;
    }
    
    // Event listeners
    this.button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      this.toggle();
      return false;
    });
    
    // Prevenir propagação em mousedown também
    this.button.addEventListener('mousedown', (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    });
    
    // Prevenir propagação em mouseup
    this.button.addEventListener('mouseup', (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    });
    
    // Prevenir propagação no tooltip e container
    this.tooltipContainer.addEventListener('click', (e) => {
      e.stopPropagation();
    });
    
    this.tooltipContainer.addEventListener('mousedown', (e) => {
      e.stopPropagation();
    });
    
    // Fechar ao clicar fora
    document.addEventListener('click', (e) => {
      if (this.isActive && !this.button.contains(e.target) && !this.tooltipContainer.contains(e.target)) {
        this.close();
      }
    });
    
    // Fechar com ESC
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isActive) {
        this.close();
      }
    });
  }
  
  toggle() {
    if (this.isActive) {
      this.close();
    } else {
      this.open();
    }
  }
  
  open() {
    // Fechar outros tooltips
    document.querySelectorAll('.pix-tooltip-container.active').forEach(container => {
      if (container !== this.tooltipContainer) {
        container.classList.remove('active');
      }
    });
    
    this.tooltipContainer.classList.add('active');
    this.isActive = true;
    
    // Acessibilidade
    this.button.setAttribute('aria-expanded', 'true');
    
    // Configurar fechamento automático se especificado
    if (this.autoCloseTime > 0) {
      this.clearAutoCloseTimer();
      this.autoCloseTimer = setTimeout(() => {
        this.close();
      }, this.autoCloseTime * 1000);
    }
  }
  
  close() {
    this.clearAutoCloseTimer();
    this.tooltipContainer.classList.remove('active');
    this.isActive = false;
    
    // Acessibilidade
    this.button.setAttribute('aria-expanded', 'false');
  }
  
  clearAutoCloseTimer() {
    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
      this.autoCloseTimer = null;
    }
  }
}

// Inicializar todos os tooltips PIX na página
function initPixTooltips() {
  const tooltipButtons = document.querySelectorAll('.pix-tooltip-button');
  tooltipButtons.forEach(button => {
    if (!button.pixTooltipInstance) {
      // Buscar o tempo de fechamento automático do atributo data
      const autoCloseTime = parseFloat(button.getAttribute('data-auto-close-time')) || 0;
      button.pixTooltipInstance = new PixTooltip(button, autoCloseTime);
    }
  });
}

// Inicializar quando o DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPixTooltips);
} else {
  initPixTooltips();
}

// Reinicializar quando seções do Theme Editor forem carregadas
document.addEventListener('shopify:section:load', () => {
  setTimeout(initPixTooltips, 100);
});

